<template>
  <div class="select-from-api">
    <multiselect
      :class="{'multiselect--multiple': multiple}"
      :value="value"
      :placeholder="placeholder"
      :searchable="true"
      :internal-search="false"
      :loading="isLoading"
      :options="options"
      :multiple="multiple"
      :hide-selected="!multiple"
      :show-no-options="false"
      open-direction="bottom"
      @input="onInput"
      @search-change="onSearchChange"
    />
    <input
      v-if="value"
      :value="value"
      type="hidden"
      :name="`${inputName}[location]`"
    />
    <input
      v-if="postalCode"
      :value="postalCode"
      type="hidden"
      :name="`${inputName}[location_postal_code]`"
    />
    <input
      v-if="country"
      :value="country"
      type="hidden"
      :name="`${inputName}[location_country]`"
    />
    <input
      v-if="region"
      :value="region"
      type="hidden"
      :name="`${inputName}[location_region]`"
    />
    <input
      v-if="city"
      :value="city"
      type="hidden"
      :name="`${inputName}[location_city]`"
    />
  </div>
</template>

<script>
    import DaData from '../api/daData'

    export default {
        name: 'SelectFromApi',
        props: {
            multiple: {
                default: false,
                type: Boolean,
            },
            value: {
                default: '',
                type: String,
            },
            placeholder: {
                default() {
                    return this.$t('location.placeholder')
                },
                type: String,
            },
            inputName: {
                type: String,
                required: true,
            },
        },
        data: () => ({
            suggestions: [],
            isLoading: false,
            searchQuery: '',
        }),
        computed: {
            options() {
                return this.suggestions.map(item => item.value)
            },
            suggestionSelected() {
                return this.suggestions.find(item => item.value === this.value)
            },
            postalCode() {
                try {
                    return this.suggestionSelected.data.postal_code
                } catch (e) {
                    return ''
                }
            },
            country() {
                try {
                    return this.suggestionSelected.data.country
                } catch (e) {
                    return ''
                }
            },
            region() {
                try {
                    return this.suggestionSelected.data.region_with_type
                } catch (e) {
                    return ''
                }
            },
            city() {
                try {
                    return this.suggestionSelected.data.city
                } catch (e) {
                    return ''
                }
            },
        },
        methods: {
            onInput($event) {
                this.$emit('input', $event)
            },
            onSearchChange(searchQuery) {
                this.searchQuery = searchQuery
                this.getFromApi()
            },
            async getFromApi() {
                if (!this.searchQuery) return
                const params = {
                    query: this.searchQuery,
                    count: 10,
                    from_bound: { value: 'city' },
                    to_bound: { value: 'city' },
                }
                const result = await DaData({ params })
                this.suggestions = result.data.suggestions
            },
        },
    }
</script>
